<template>
  <div>
    <title-component :size="1">
      <translate>Cases</translate>
    </title-component>
    <table-component-buefy
      v-if="mixin.loaded"
      :content="cases"
      :headings="headings"
      :item_keys="item_keys"
      :display_spec="caseSpecs"
      :total_items="mixin.total_items"
      :pagination_callback="mixin.loadItems"
      :hidden_columns="['modified', 'created']">
    </table-component-buefy>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { caseSpecs } from '@/display_context/display_context'
  import { loadItemsMixin } from '@/mixins/mixins'
  import TitleComponent from '@/components/layout/TitleComponent'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'

  export default {
    name: 'customer-cases-view',
    mixins: [loadItemsMixin],
    components: {
      TitleComponent,
      TableComponentBuefy
    },
    data () {
      return {
        headings: ['Case number', 'Certification', 'Qualification', 'Case type', 'Created', 'State', 'Responsible', 'Progress', 'Updated'],
        item_keys: ['caseLink', 'service.shortName', 'qualification.value', 'caseType.display', 'created', 'state', 'responsible.profileTypeDisplay', 'progress', 'modified'],
        caseSpecs: caseSpecs,
        mixin: { actionMethod: this.getCases }
      }
    },
    computed: {
      ...mapState({
        cases: state => state.caseModule.cases
      })
    },
    methods: {
      ...mapActions([
        'getCases'
      ])
    }
  }
</script>
